export default "__VITE_ASSET__EyyREIQp__"